import { GridSortItem } from '@mui/x-data-grid-pro';
import { createStore, withProps } from '@ngneat/elf';
import { withEntities, withUIEntities } from '@ngneat/elf-entities';
import { withPagination } from '@ngneat/elf-pagination';
import { withRequestsStatus } from '@ngneat/elf-requests';

import { TableConfig } from '@constants/table.constants';

import { Client, ClientsFilters, ClientUI } from '@store/clients/clients.model';
import { GlobalStatus } from '@store/common/globalStatus.enum';
import { TablePagination } from '@store/common/pagination.model';

export interface ClientsState {
  status?: GlobalStatus;
  filters: ClientsFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
}

export const clientsStore = createStore(
  {name: 'clients'},
  withProps<ClientsState>({
    status: undefined,
    filters: {search: '', tableFilters: ClientsFilters.initTableFilters()},
    sort: {
      field: 'organisation.name',
      sort: 'asc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withEntities<Client>(),
  withUIEntities<ClientUI>(),
  withPagination(),
  withRequestsStatus(),
);